import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 国际化语言包
import Cn from '../lang/zh-cn'
import En from '../lang/en'
import Ru from '../lang/ru'

const lang = localStorage.getItem('lang') || 'zh-cn'
const messages = {
    'zh-cn': Cn,
    en: En,
    ru:Ru
}

const i18n = new VueI18n({
    locale: lang,
    messages,
    fallbackLocale: lang
})

export default i18n